import { render, staticRenderFns } from "./serviceItemAllOrder.vue?vue&type=template&id=19da6be6&scoped=true&"
import script from "./serviceItemAllOrder.vue?vue&type=script&lang=ts&"
export * from "./serviceItemAllOrder.vue?vue&type=script&lang=ts&"
import style0 from "./serviceItemAllOrder.vue?vue&type=style&index=0&id=19da6be6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19da6be6",
  null
  
)

export default component.exports